import React, { useState, useEffect } from "react";
import "./AvisoCookies.css";

export default function AvisoCookies() {
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    const consentimento = localStorage.getItem("cookiesConsentido");
    if (!consentimento) {
      setMostrar(true);
    }
  }, []);

  const aceitar = () => {
    localStorage.setItem("cookiesConsentido", "aceito");
    setMostrar(false);
  };

  const rejeitar = () => {
    localStorage.setItem("cookiesConsentido", "rejeitado");
    setMostrar(false);
  };

  if (!mostrar) return null;

  return (
    <div className="aviso-cookies">
      <p>
        Utilizamos cookies para personalizar sua experiência e melhorar nossos serviços. Ao continuar, você concorda com nossa
        <a href="https://tikpag.com.br/politica-de-cookies" target="_blank" rel="noopener noreferrer"> Política de Cookies</a>.
      </p>
      <div className="botoes">
        <button onClick={aceitar}>Aceitar</button>
        <button onClick={rejeitar} className="rejeitar">Rejeitar</button>
      </div>
    </div>
  );
} 
